import * as React from 'react';

export const InputError: React.FC<React.ComponentProps<'p'>> = ({
  className = '',
  ...props
}) => {
  return <p {...props} className={`${className} text-xs text-red`} />;
};
